const homeAudiencesPath = '/app/audiences';
const homeOrganizationsPath = '/app/organizations';
const homePath = '/app/dashboard';
const conversationsPath = '/app/conversations';

// Matches audience/organization detail pages (but not the create-segment sub-route).
const detailsPageRegex = /^\/app\/(organizations|audiences)\/[0-9]*\/(?!create-segment)/;
const isDetailsPagePath = (pathname: string) => detailsPageRegex.test(pathname);

export { conversationsPath, homeAudiencesPath, homeOrganizationsPath, homePath, isDetailsPagePath };
